import EquipmentStore from "../stores/EquipmentStore"
import HierarchySettingsStore from "../stores/HierarchySettingsStore"
import AuthenticationStore from "../stores/AuthenticationStore"
import dispatcher from "../dispatcher"
import { IEquipmentDocument, ITimecardFullData } from "../models"
import * as api from "../api"
import AppStateStore from "../stores/AppStateStore"

export function getEquipmentList(hierarchyItemId, page, limit, search, cb = null) {
    const accountId = AuthenticationStore.getCookieAccountId()
    const hierarchyItemIdForApi = hierarchyItemId === null ? "" : hierarchyItemId
    api.getEquipmentList(accountId, hierarchyItemIdForApi, page / limit, limit, search).then(function (response) {
        const payload = {
            totalDocumentCount: response.data.TotalDocumentCount,
            documents: response.data.Documents,
            page,
            limit,
            search
        }
        dispatcher.dispatch({
            type: "GET_EQUIPMENT_List",
            data: payload
        })
        if (cb && typeof cb === "function") {
            cb()
        }
    })
}

export function getEquipment(equipmentId, cb = null) {
    api.getEquipment(equipmentId).then(function (response) {
        dispatcher.dispatch({
            type: "SELECTED_EQUIPMENT",
            data: response.data
        })
        if (cb && typeof cb === "function") cb()
    })
}

export function getEquipmentTimecard(equipmentId, referenceDate, msg: string) {
    api.getEquipmentTimecard(equipmentId, referenceDate).then(res => {
        dispatcher.dispatch({
            type: "SELECTED_EQUIPMENT_TIMECARD",
            data: res.data as ITimecardFullData
        })
        AppStateStore.setProgressSnackbarContent(msg ? msg : null)
    })
}

export function addEquipment(equipment, cb = null) {
    const limit = EquipmentStore.getLimit()
    const hierarchyItemId = HierarchySettingsStore.getGlobalLevelItemFilterId()
    api.addEquipment(equipment).then(function (response) {
        getEquipmentList(hierarchyItemId, 0, limit, "", cb)
    })
}

export function updateEquipment(equipment, cb = null) {
    api.updateEquipment(equipment).then(function (response) {
        dispatcher.dispatch({
            type: "SELECTED_EQUIPMENT",
            data: response.data
        })
        if (cb && typeof cb === "function") cb()
    })
}

export function deleteEquipment(equipmentId) {
    const limit = EquipmentStore.getLimit()
    const hierarchyItemId = HierarchySettingsStore.getGlobalLevelItemFilterId()
    return new Promise(function (resolve, reject) {
        api.deleteEquipment(equipmentId).then(function (response) {
            getEquipmentList(hierarchyItemId, 0, limit, "")
            resolve("success")
        })
    })
}

export function equipmentExternalIdExists(accountId, externalId) {
    return api.equipmentExternalIdExists(accountId, externalId).then(function (response) {
        return response
    })
}

export function getEquipmentForChip(equipmentId) {
    return new Promise((resolve, reject) => {
        api.getEquipment(equipmentId).then(res => {
            resolve(res.data as IEquipmentDocument)
        })
    })
}

export function setFilterText(filterText = "") {
    dispatcher.dispatch({
        type: "UPDATE_EQUIPMENT_FILTER_TEXT",
        data: filterText
    })
}
